import { Outlet, ScrollRestoration, useMatch } from "react-router";
import { DonateDialog } from "../features/donate";
import { ByForlais } from "../features/footer/ByForlais";
import { SiteNav } from "../features/navigation";
import { routePatterns } from "./routes";
import "./site-layout.css";

export function SiteLayout() {
  const onHome = useMatch(routePatterns.home) !== null;
  return (
    <div className="site-layout" data-page={onHome ? "home" : "inner"}>
      <SiteNav />
      <Outlet />
      <ByForlais />
      <DonateDialog />
      <ScrollRestoration />
    </div>
  );
}
